<template>

    <ion-row>

      <ion-col>
        <h2>
          Data & Artifical Intelligence
        </h2>
      </ion-col>

    </ion-row>

    <ion-row>

      <ion-col>
        <ion-card>
          <ion-card-header>
            <h3>A.I. Strategy</h3>
          </ion-card-header>
          <ion-card-content>
            <ion-icon :icon="navigate" size="large"></ion-icon>
          </ion-card-content>
        </ion-card>
      </ion-col>

      <ion-col>
        <ion-card>
          <ion-card-header>
            <h3>Data Engineering and Maturity</h3>
          </ion-card-header>
          <ion-card-content>
            <ion-icon :icon="information" size="large"></ion-icon>
          </ion-card-content>
        </ion-card>
      </ion-col>

      <ion-col>
        <ion-card>
          <ion-card-header>
            <h3>A.I. Process Development</h3>
          </ion-card-header>
          <ion-card-content>
            <ion-icon :icon="analytics" size="large"></ion-icon>
          </ion-card-content>
        </ion-card>

      </ion-col>

      <ion-col>
        <ion-card>
          <ion-card-header>
            <h3>Software Development Principle Enhancement</h3>
        </ion-card-header>
          <ion-card-content>
            <ion-icon :icon="build" size="large"></ion-icon>
          </ion-card-content>
        </ion-card>
      </ion-col>

      <ion-col>
        <ion-card>
          <ion-card-header>
            <h3>Testing and Validation</h3>
          </ion-card-header>
          <ion-card-content>
            <ion-icon :icon="search" size="large"></ion-icon>
          </ion-card-content>
        </ion-card>
      </ion-col>

      <ion-col>
        <ion-card>
          <ion-card-header>
            <h3>Production Deployment</h3>
          </ion-card-header>
          <ion-card-content>
            <ion-icon :icon="airplane" size="large"></ion-icon>
          </ion-card-content>
        </ion-card>
      </ion-col>

      <ion-col>
        <ion-card>
          <ion-card-header>
            <h3>Monitoring, Logging and Alerting</h3>
          </ion-card-header>
          <ion-card-content>
            <ion-icon :icon="alarm" size="large"></ion-icon>
          </ion-card-content>
        </ion-card>
      </ion-col>

    </ion-row>

</template>

<script>
import { navigate, analytics, information, build, airplane, search, alarm } from "ionicons/icons"

import { IonRow, IonCol, IonCard, IonIcon, IonCardContent, IonCardHeader } from '@ionic/vue';

export default {
  name: 'Home',
  components: {
    IonRow,
    IonCol,
    IonCard,
    IonIcon,
    IonCardContent,
    IonCardHeader
  },
  setup() {
        return {
            navigate, analytics, information, build, airplane, search, alarm
        }
    }
}

</script>

<style>
.avatar{
   margin: auto;
}
</style>
